var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.625C9.375 0.933594 8.81641 0.375 8.125 0.375C7.43359 0.375 6.875 0.933594 6.875 1.625V7.25H1.25C0.558594 7.25 0 7.80859 0 8.5C0 9.19141 0.558594 9.75 1.25 9.75H6.875V15.375C6.875 16.0664 7.43359 16.625 8.125 16.625C8.81641 16.625 9.375 16.0664 9.375 15.375V9.75H15C15.6914 9.75 16.25 9.19141 16.25 8.5C16.25 7.80859 15.6914 7.25 15 7.25H9.375V1.625Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.387407afaea6565a4737b2f8dfb2de80.svg";
export { ForwardRef as ReactComponent };